import { isAfter, isBefore, parseISO, isSameDay, format as formatFn } from 'date-fns';
import { END_DATE, START_DATE } from './../../useDatePicker/useDatePicker/useDatePicker';

const getIsAIncludedDates = (includedDates: string[], date_: string) => {
  const isAExcludedDate = includedDates.some((date: string) => date === date_);
  return isAExcludedDate;
};

const getIsAExcludedDates = (
  excludedDates: string[],
  date: Date,
  formatFn: (date: Date, format: string) => string
) => {
  for (let index = 0; index < excludedDates.length; index++) {
    const element: any = excludedDates[index];
    if (typeof element === 'string') {
      const formatDate = formatFn(date, 'YYYY-MM-DD');
      if (formatDate === element) {
        return true;
      }
    } else if (element?.start && element?.end) {
      const startDate = parseISO(element?.start);
      const endDate = parseISO(element?.end);
      if (
        isSameDay(date, startDate) ||
        isSameDay(date, endDate) ||
        (isBefore(date, endDate) && isAfter(date, startDate))
      ) {
        return true;
      }
    }
  }
  return false;
};

const getIsValidDaysOfWeek = (validDaysOfWeek: string[], date: Date) => {
  const isValidDaysOfWeek = validDaysOfWeek.some(
    (daysOfWeek: string) =>
      daysOfWeek.toLocaleUpperCase() === formatFn(date, 'eeee').toLocaleUpperCase()
  );
  return isValidDaysOfWeek;
};

const isInOriginalIntervale = (date: Date, minDate_: Date, maxDate_: Date) => {
  return (
    isSameDay(date, minDate_) ||
    isSameDay(date, maxDate_) ||
    (isAfter(date, minDate_) && isBefore(date, maxDate_))
  );
};

const getDayStatus = ({
  date,
  minDate,
  maxDate,
  validDaysOfWeek,
  includedDates,
  excludedDates,
  formatFn
}: any) => {
  const minDate_ = parseISO(minDate);
  const maxDate_ = parseISO(maxDate);

  let isAValidDayOfWeek;
  let isAIncludedDates;
  let isAExcludedDates;

  if (validDaysOfWeek) {
    isAValidDayOfWeek = getIsValidDaysOfWeek(validDaysOfWeek, date);
  }
  if (includedDates) {
    isAIncludedDates = getIsAIncludedDates(includedDates, formatFn(date, 'YYYY-MM-DD'));
  }
  if (excludedDates) {
    isAExcludedDates = getIsAExcludedDates(excludedDates, date, formatFn);
  }

  if (isInOriginalIntervale(date, minDate_, maxDate_)) {
    if (validDaysOfWeek) {
      if (excludedDates) {
        if (!isAValidDayOfWeek || isAExcludedDates) {
          return true;
        }
      } else {
        if (!isAValidDayOfWeek) {
          return true;
        }
      }
      return false;
    } else if (excludedDates) {
      if (isAExcludedDates) {
        return true;
      } else {
        return false;
      }
    }
  } else {
    if (validDaysOfWeek) {
      if (includedDates) {
        if (!isAValidDayOfWeek) {
          return true;
        }
        if (isAIncludedDates) {
          if (isAValidDayOfWeek) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        if (isAValidDayOfWeek) {
          return false;
        } else {
          return true;
        }
      }
    } else if (includedDates) {
      if (isAIncludedDates) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }
  return false;
};

const isInUnavailableFetchDates = (
  unavailableDates: any = {},
  date: Date,
  focusedInput: string | null,
  formatFn: (value: Date, format: string) => string
) => {
  if (unavailableDates) {
    if (focusedInput === START_DATE) {
      if (unavailableDates?.departure) {
        const {
          minDate,
          maxDate,
          validDaysOfWeek,
          includedDates,
          excludedDates
        } = unavailableDates?.departure;

        return getDayStatus({
          date,
          minDate,
          maxDate,
          validDaysOfWeek,
          includedDates,
          excludedDates,
          formatFn
        });
      }
    } else if (focusedInput === END_DATE) {
      if (unavailableDates?.return) {
        const {
          minDate,
          maxDate,
          validDaysOfWeek,
          includedDates,
          excludedDates
        } = unavailableDates?.return;

        return getDayStatus({
          date,
          minDate,
          maxDate,
          validDaysOfWeek,
          includedDates,
          excludedDates,
          formatFn
        });
      }
    }
  }
  return false;
};

export { isInUnavailableFetchDates };
